import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from '@reach/router'
import * as PathHelpers from '../helpers/path'
import { ResponsiveContext } from './responsiveContext'

export const SideMenuContext = React.createContext({
  active: '',
  submenu: null,
  setSubmenu: () => {},
  menuStates: {},
  handleUserNavigation: {},
  isMenuOpen: false,
  toggleMenu: () => {},
})

const SideMenuProvider = ({ children }) => {
  const { pathname } = useLocation()
  const [activePathname, setActivePathname] = useState()
  const [isFixedOpen, setIsFixedOpen] = useState(false)
  const [isHoveredOpen, setIsHoveredOpen] = useState(false)
  const [submenu, setSubmenu] = useState(null)
  const { maxMobileQuery } = useContext(ResponsiveContext)

  useEffect(() => {
    const { category } = PathHelpers.getDataByPath(pathname)

    setSubmenu(category)
  }, [setSubmenu]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const pathnameWithoutPrefix = process.env.GATSBY_PATH_PREFIX ? pathname.replace(`/${process.env.GATSBY_PATH_PREFIX}`, '') : pathname

    setActivePathname(pathnameWithoutPrefix)
  }, [pathname])

  function handleMouseEnter() {
    if (!isHoveredOpen && window.innerWidth > maxMobileQuery) {
      setIsHoveredOpen(true)
    }
  }

  function handleMouseLeave() {
    if (isHoveredOpen) {
      setIsHoveredOpen(false)
    }
  }

  function handleKeyDown(event) {
    if (event.key === 'Escape') {
      setIsHoveredOpen(false)
    }
  }

  const menuStates = {
    isHoveredOpen,
    isFixedOpen,
  }

  const handleUserNavigation = {
    onMouseEnter: handleMouseEnter,
    onFocus: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onBlur: handleMouseLeave,
    onKeyDown: handleKeyDown,
  }

  return (
    <SideMenuContext.Provider
      value={{
        activePathname,
        submenu,
        setSubmenu,
        menuStates,
        handleUserNavigation,
        maxMobileQuery,
        isMenuOpen: isHoveredOpen || isFixedOpen,
        toggleMenu: () => setIsFixedOpen(oldValue => !oldValue),
      }}
    >
      {children}
    </SideMenuContext.Provider>
  )
}

export default SideMenuProvider
